<template>
  <tabs parent="invoice_list">
    <tab id="list" :name="translate('invoice.many')" :href="url+'list'" >
      <List />
    </tab>

    <tab id="currency_rate" :name="translate('invoice.currency_rate')" :href="url+'currency_rate'" >
      <CurrencyRate />
    </tab>

  </tabs>
</template>

<script>

import {Tabs, Tab} from 'components/UIComponents/Tabs'
import List from './Tabs/List/Index.vue'
import CurrencyRate from './Tabs/CurrencyRate/Index.vue'

export default {
  name: 'Invoices',
  components:{
    Tab,
    Tabs,
    List,
    CurrencyRate
  },
  props: {
  },
  data () {
    return {
      load: true,
    }
  },
  computed: {
    url () { return '/invoice_list/' }
  },

}
</script>
